<template>
  <el-dialog title="修改密码"
             :close-on-click-modal="false"
             width="600px"
             :visible.sync="visible"
             append-to-body>
    <el-form :model="form" :rules="rules" ref="dataForm" @keyup.enter.native="formSubmit()" label-width="80px">
      <el-form-item label="用户账号" prop="account">
        <el-input v-model="form.account" maxlength="15" placeholder="请输入账号" readonly></el-input>
      </el-form-item>
      <el-form-item label="用户名称" prop="name">
        <el-input v-model="form.name" maxlength="15" placeholder="请输入用户名" readonly></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input v-model="form.password" maxlength="20" type="password" show-password placeholder="请输入密码"
                  clearable></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="primary" ref="formSubmit" @click="formSubmit()">确定</el-button>
      <el-button @click="visible = false">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { isLogin, update} from "@/api/user";
import {encryptPassword} from "@/util";

export default {
  data() {
    return {
      visible: false,
      form: {
        account: '',
        roleCode: '',
        name: '',
        phone: '',
        password: '',
        order: 0,
      },
      rules: {
        account: [{required: true, message: "用户账号不能为空", trigger: "blur"}],
        name: [{required: true, message: "用户名称不能为空", trigger: "blur"}],
        password: [{required: true, message: "密码不能为空", trigger: "blur"}],
      },
      roleList: []
    }
  },
  computed: {
    account() {
      return this.$store.state.account
    },
    token() {
      return this.$store.state.token
    }
  },
  methods: {
    async init() {
      this.visible = true;
      isLogin({account: this.account, token: this.token}).then(data => {
        if(data.code === 200) {
          this.form = data.data.records
          this.form.password = ''
          console.log(this.form)
        }else {
          this.$message.warning('获取信息失败，请重新登录！')
        }
      }).catch(() => {})
    },
    formSubmit() {
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          if (this.form.id) {
            let form = {...this.form}
            form.password = encryptPassword(this.form.password)
            update(this.form.id, form).then(data => {
              if (data.code === 200) {
                this.$emit("resetData")
                this.$message.success(data.msg)
                this.visible = false
              } else {
                this.$message.error(data.msg)
              }
            })
          }
        }
      })
    }
  }
}
</script>
